require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-wird-gepflastert.json") })
        }
      }, "path---es-wird-gepflastert");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-wird-gepflastert!./.cache/json/es-wird-gepflastert.json
// module id = 423
// module chunks = 231608221292675